import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
import { META_PIXEL_ID } from './data/content';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23vkuoemiy5k6">
      <div className="min-h-screen w-full bg-canvas font-sans text-ink selection:bg-accent selection:text-canvas" data-id="element-1" data-mp="23ujl6el5pr4k">
        <noscript data-id="element-2" data-mp="3ijpd910hgz9r">
          <img height="1" width="1" style={{
          display: 'none'
        }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="3ii4r9zs8ioni" />
        </noscript>

        <Hero data-id="element-4" data-mp="680frswe88f" />
        <main data-id="element-5" data-mp="4n5w26l2pak">
          <ProblemSection data-id="element-6" data-mp="56ntiw8hdol" />
          <SolutionSection data-id="element-7" data-mp="2zl39tfhhuw2o" />
          <BonusesSection data-id="element-8" data-mp="2zlv6ktmtuzuj" />
          <BenefitsSection data-id="element-9" data-mp="2zmem63p09c5e" />
          <OfferSection data-id="element-10" data-mp="2zn678kkz7rhf" />
          <GuaranteeSection data-id="element-11" data-mp="33mf0loc3tncg" />
          <Testimonials data-id="element-12" data-mp="33nq55qddiz4m" />
          <FAQSection data-id="element-13" data-mp="33mykhalbelt4" />
          <FinalCTA data-id="element-14" data-mp="33oi0d0326uud" />
        </main>
        <Footer data-id="element-15" data-mp="38li77d7qg1mj" />
        <PurchasePopup data-id="element-16" data-mp="38l05i12awv78" />
      </div>
    </MotionConfig>;
}